/**
 * 已出货订单详情
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {
    Spin,
    Row,
    Col,
    Space,
    Button,
    Input,
    Divider,
    Dropdown,
    Card,
    message,
    Alert,
    Badge
} from 'antd';
import EssaModal from "@components/EssaModal/EssaModal";
import ModalFormComponent from '@components/ModalForm/ModalForm';
import Lang from "@components/Lang/Lang";
import {isEmpty} from '@utils/utils';
import { toFixedWithCommas} from "@utils/number-util";
import ShipperManagementAction from "../../ShipperManagement.action";
import {getRandomString} from "@utils/utils";
import {DownCircleOutlined} from "@ant-design/icons";
import PicturePreview from '@components/PicturePreview/PicturePreview';
import { VerticalAlignBottomOutlined,ReloadOutlined,} from '@ant-design/icons';
import dayjs from "dayjs";
import Locale from "@utils/locale";
import config from "@config/config";
import StickerPicturePreview from '../../component/StickerPicturePreview';
import CabinetPicturePreview from '../../component/CabinetPicturePreview';
import LogisticsInformation from "../../../../components/Logistics/LogisticsInformation";
import LogisticsFollowUp from "./logisticsFollowUp/LogisticsFollowUp";
import CustomsClearance from "../customsClearance/CustomsClearance";
import FileManagement from "../FileManagement";
import "./Detail.less";

const { Search } = Input;
class EstimatedShippingOrderDetail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list:[],
            model:{},
            conTruckingListVO:{//随车单信息
                // truckingListCreateBy:'Абутьева Мария Викторовна',
                // truckingListCreateTime:1231234564671,
                // truckingListStatus:11,
            },
            finalPaymentList:[],
            dropdownStatus:{//下拉数据

            },
            showConfirmFile:false,
            // 上传 弹窗
            options:[],
            title:{},
            showUploadFile:false,
            statuInfoCount:0
        }
    }
    /**
     * 查看详情
     * */
    getDetail(sId){
        this.loading(true);
        const postData = {
            containerId:sId,
        }
        ShipperManagementAction.getContainerOrderTop(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
        this.getDetailStatus(sId)
    }
    /**
     * 查看各个报表状态
     * * */
    getDetailStatus(sId){
        const postData = {
            containerId:sId,
        }
        ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/queryConReportOrderStatus').then(res=>this.handlelStatusRes(res.data)).catch(err=>this.handlelStatusRes(err));
    }
    /**
     * 设置 信息
     * */
    handlelStatusRes(res,){
        const {success,valid} = res;
        if(success&&valid){
            const statuInfo = res.model||{}
            let statuInfoCount = 0;
            for(let key in statuInfo) {
                if(statuInfo[key]=='10') statuInfoCount += 1;
            }
            this.setState({
                statuInfoCount: statuInfoCount,
            })
        }else if(res.message){
                message.warning(res.message);
            }
    }
    handleRes(res){
        this.loading(false);
        const {success,valid,model={}} = res;
        if(success&&valid){
            const conTruckingListVO = model.conTruckingListVO || {};
            this.setState({
                model: model||{},
                conTruckingListVO:conTruckingListVO //随车单信息
            })
        }else if(res.message)message.warning(res.message);
    }
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    getCerId(str){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        this.setState({
            iId: iId
        })
        return iId;
    }
    /**
     * 渲染列表
     * @list 数据源
     * @type 编辑类型 edit 可编辑 view 查看状态，不可编辑
     * @certDict 证书类型
     * **/
    renderList = (item,inx,containerId) =>{
            return(<div className={'itemLi'} key={inx}>
                <div className={'top'}>
                    <div>
                        <div className={'title'}>
                            <Dropdown overlayClassName='comment-scrollbar' dropdownRender={(menu) =>this.showPhoneList()} trigger={['click']}>
                                <a className="font-blue" onClick={()=>this.getPhoneList(item,containerId)}>
                                    {item.buyerCode}<DownCircleOutlined />
                                </a>
                            </Dropdown>
                        </div>
                        <div className={'subtitle'}>
                            <Space size={'small'}>
                                <span>{Lang({id: 'KuanShu', default: '款数'})}</span>
                                <span className="txt">{item.skuCount||'-'}</span><Divider type="vertical" />
                                <span>{Lang({id: 'XiangShu', default: '箱数'})}</span>
                                <span className="txt">{item.quantity||'-'}</span><Divider type="vertical" />
                                <span>{Lang({id: 'TiJi', default: '体积'})}</span>
                                <span className="txt">{toFixedWithCommas(item.totalVolume,3)||'-'} m³</span>
                            </Space>
                        </div>
                    </div>
                   <div>
                       <div className={'payCount'}>
                           {item.isPay ==1?(<span>{Lang({id: 'YiZhiFuWeiKuan', default: '已支付尾款'})}</span>)
                                   : (<div className="" data-flex="cross:center" onClick={()=>this.handleFinalPayment(item,containerId)}>
                                       <span>{Lang({id: 'YingShouWeiKuan', default: '应收尾款'})}：</span>
                                       <Dropdown overlayClassName='comment-scrollbar'
                                                 dropdownRender={(menu) =>this.renderFinalPaymentList(menu)}
                                                 trigger={['click']}>
                                           <a className="" style={{color: '#1F2329'}} >
                                               {item.currencySymbol} {parseFloat(item.amount||0).toFixed(2)} <DownCircleOutlined />
                                           </a>
                                       </Dropdown>
                                   </div>)}

                       </div>
                       {item.invoiceFileUrl&&<div className={'textRight'} onClick={()=>this.openPayCert(item.invoiceFileUrl)}>{ Lang({id: 'FuKuanPingZheng', default: '付款凭证'})}</div>}
                   </div>
                </div>
                {item.poList&&item.poList.length>0&&this.renderPoList(item.poList)}
            </div>)

    }
    renderPoList(list=[]){
        let children = [];
        list.forEach((item,inx)=>{
            children.push(<div className={'poLi'} key={inx}>
                <div className={'poCodeTile'}>
                   <div className={'poCodeLine'}>
                       <span className={"spanBlue mr_16 flex-item-ver-center"}>
                            <i className="ri-file-list-2-fill mr_4 font_24" />
                            <span className={"spanCode"}>{item.poCode}</span>
                       </span>
                        {/* 查看贴纸排版图 */}
                       {item.hasOldStickerLayout==1?<StickerPicturePreview item={item} loading={flag=>this.loading(flag)} />:null}
                       {item.transitCityName&&<span className={"ml_16 black66"}>{item.transitCityName}{Lang({id: 'CangKu', default: '仓库'})}</span>}
                   </div>
                </div>
                {item.skuList&&item.skuList.map((sku,inx) => (<div className={'skuLi'} key={inx}>
                    <div className={'thumbnailWrap'}>
                        {sku.skuPictureUrl&&<img src={sku.skuPictureUrl} />}
                        <div className={'skuNo'}>
                            {Lang({id: 'ShangPinBianMa2', default: '商品编码2'})}<span>{sku.skuNo}</span>
                        </div>
                        {/*<div className={"text-center mt_8"}>*/}
                            {/*/!*<Button className={"ant-btn-primary-blue"} block onClick={()=>this.applyVerify(sku.poItemId)}>*!/*/}
                                {/*/!*{Lang({id: "ShouHouTuiKuan",default: "售后退款"})}*!/*/}
                            {/*/!*</Button>*!/ */}
                        {/*</div>*/}
                        <div className={"text-center mt_16 ant-btn-primary-blue btnAfterSale cursor-p"}onClick={()=>this.applyVerify(sku.poItemId)}>
                            {Lang({id: "ShouHouTuiKuan",default: "售后退款"})}
                        </div>
                    </div>
                    <div className={'info'}>
                        <h4>{sku.skuName}</h4>
                        <Row className={'infoDetail'}>
                            <Col>{Lang({id: 'DanJia', default:'单价'})}<span>{sku.currencySymbol}&nbsp;{sku.price}</span></Col>
                            <Col offset={1}>{Lang({id: 'XiangShu', default:'箱数'})}<span>{sku.quantity}</span></Col>
                            <Col offset={1}>{Lang({id: 'JinE', default:'金额'})}<span>{sku.currencySymbol}&nbsp;{sku.priceTotal}</span></Col>
                        </Row>
                        <div className={'attributeDetail'}>
                            <p className={'nameProduct'}>
                                {sku.skuNameRu}</p>
                            <div className={'attList'}>
                            {this.renderAttribute(sku.attributeList,sku.customsCode,sku.mainMaterials)}
                            </div>
                        </div>
                        <div className={'picList'}>
                            <Space>
                                {/*  todo 对接*/}
                                <PicturePreview list={sku.stickerLayoutPicList} moreNum={4} title={Lang({id: 'TieZhiPaiBanTu', default: '贴纸排版图'})} />
                                <PicturePreview list={sku.goodsPicList} moreNum={4} title={Lang({id: 'BaoZhuangLiuMianTu', default: '包装六面图'})} />
                                <PicturePreview list={sku.qualityTestPicList} moreNum={4} title={Lang({id: 'ZhiJianTuPian', default: '质检图片'})} />
                            </Space>
                        </div>
                    </div>
                </div>))}

            </div>)
        });
        return children;
    }
    /*
    * 发起索赔
    * 申请索赔校验 http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7966
    * */
    applyVerify(poItemId){
        if(poItemId){
            this.loading(true)
            const sCheckUrl = "/service/mg/sale/claimDemage/applyVerify";
            ShipperManagementAction.autoFetchAction({
                poItemId:poItemId
            },sCheckUrl).then(( res={}) =>this.handleCheckRes(res.data,poItemId)).catch(err=>this.handleCheckRes(err))
        }
    }
    handleCheckRes(resData={},poItemId){
        // 响应结果
        this.loading(false)
        const { success,valid,model={}} = resData;
        if(success&valid){
            // 跳转 发起申请
            this.props.history.push('/afterSale/initiated?poItemId='+poItemId+'&containerId='+this.state.iId)
        }else if(resData.message){
            message.error(resData.message);
        }else message.error(Lang({id:"CaoZuoShiBai",default:"操作失败"}));
    }
    /**
     * 打开 付款凭证
     * */
    openPayCert(url){
        window.open(url)
    }
    // 获取尾款数据
    handleFinalPayment(row,containerId) {
        if (this.state.dropdownStatus.buyerId === row.buyerId && this.state.dropdownStatus.type === 'finalPayment') { // 避免重复请求
            return
        }
        this.setState({
            finalPaymentList: [],
        }, () => {
            ShipperManagementAction.postFinalPayment({
                buyerId: row.buyerId,
                containerId: containerId,
            }).then(res => {
                this.setState({
                    finalPaymentList: res.data.models,
                    dropdownStatus: {
                        buyerId: row.buyerId,
                        type: 'finalPayment'
                    },
                })
            })
        })
    }
    // 渲染
    renderFinalPaymentList (){
       const {finalPaymentList} = this.state;
       return(<div>
            <Card title={Lang({id: 'YingShouWeiKuan', default: "应收尾款"})}
            bordered={false}
            bodyStyle={{maxHeight: '324px', overflowY:'auto'}}
            style={{ width: '700px', }}>
            {!finalPaymentList.length && <Spin />}
            {finalPaymentList.map((item, index) => (
                <div className="card-wei-kuan-item" data-flex="main:justify cross:center" key={index.toString()}>
                    <span style={{color: '#646A73'}}>{Lang({id: 'DingDan', default: '订单'})} {item.poCode}</span>
                    {
                        item.status === 'CONFIRMED'
                            ? (<span style={{color: '#1F2329'}}>{Lang({id: 'YiZhiFuWeiKuan', default: '已支付尾款'})}：{item.symbol} {parseFloat(item.amountExtra||0).toFixed(2)}</span>)
                            : null
                    }
                    {
                        item.status === 'TO_BE_CONFIRM'
                            ? (<span style={{color: '#1F2329'}}>{Lang({id: 'WeiKuan', default: '尾款'})}：{item.symbol} {parseFloat(item.amountExtra||0).toFixed(2)}</span>)
                            : null
                    }
                </div>
            ))}

            </Card>
            </div>)
    }
    // 属性列表
    renderAttribute(attributeList=[],customsCode='',mainMaterials=''){
        let childAtt = [];
        if(!isEmpty(customsCode)){
            childAtt.push(<div key={'customsCode'} className={'descItem'}>
                {Lang({id: 'HaiGuanBianMa', default: '海关编码'})}<span>{customsCode}</span>
            </div>)
        }
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0)childAtt.push(<div key={inx} className={'descItem'}>{att.attributeName}{att.optionList&&att.optionList.map((item, suInx)=>(<span key={suInx}>{item.optionName}</span>))}</div>)
        })
        if(!isEmpty(mainMaterials)){
            childAtt.push(<div key={'mainMaterials'} className={'descItem'}>
                {Lang({id: 'CaiZhi', default: '材质'})}<span>{mainMaterials}</span>
            </div>)
        }
        return childAtt;
    }
    /**
     * 联系人信息列表
     * */
    getPhoneList(data,containerId){
        const postData = {
            buyerId: data.buyerId,
            containerId: containerId,
        }
        ShipperManagementAction.getPurchaserInfo(postData).then(res=>this.handlePhoneListRes(res.data)).catch(err=>this.handlePhoneListRes(err))
    }
    handlePhoneListRes(res){
        const {success,valid,models,} = res;
        if(success&&valid){
            this.setState({
                phoneList:models||[],
            })
        }else {
            if(res.message)message.error(res.message);
            this.setState({
                phoneList:models||[],
            })
        }
    }
    showPhoneList = ()=>{
        const {phoneList=[]} = this.state;
         return ( <div>
                 <Card title={Lang({id: 'LianXiRenXinXi', default: "联系人信息"})}
                       bordered={false}
                       bodyStyle={{padding: '16px 24px 24px', maxHeight: '380px', overflowY:'auto'}}
                       style={{ width: '479px', }}>
                     {!phoneList.length && <Spin />}
                     {
                         phoneList.map((item, index) => (
                             <div className="card-phone-item test" key={index.toString()}>
                                 <p data-flex="cross:center" className="mb_10">
                                     <i className="iconfont icon-essa-hd-me mr_12" style={{color: '#646A73', fontSize: '18px'}}></i>

                                     <span className="item-txt-1 mr_34">{item.type==0?Lang({id: 'XiaDanRen', default: '下单人'}):Lang({id: 'ShouHuoRen', default: '收货人'})}</span>
                                     <span className="item-txt-2 flex1">{item.name}</span>
                                 </p>
                                 <p data-flex="cross:center" className="">
                                     <i className="iconfont icon-dianhua mr_12" style={{color: '#646A73', fontSize: '18px'}}></i>
                                     <span className="item-txt-1 mr_16">{Lang({id: 'ShouJiHaoMao', default: '手机号码'})}</span>
                                     <span className="item-txt-2 flex1">{item.mobile}</span>
                                 </p>
                             </div>
                         ))
                     }
                 </Card>
             </div>
         )
    }
    /**
     * 更新随车单
     * */
    updateData(containerId){
        this.loading(true);
        const postData = {
            containerId:containerId,
            status: 40, // 更新为已确认状态 = 40
        }
        ShipperManagementAction.updateTruckingListStatus(postData).then(res=>this.handleUpdateRes(res.data,containerId)).catch(err=>this.handleUpdateRes(err,containerId));
    }
    handleUpdateRes(res,containerId){
        this.loading(false);
        const {success,valid,model={}} = res;
        if(success&&valid){
            this.getDetail(containerId);
            this.clickConfirmFile()
        }else if(res.message)message.warning(res.message);
    }
    /**
     * 单据管理
     * */
    showBill(containerId){
        /*let currLocaleLang = Locale.current();
        if(currLocaleLang=='en'){
            currLocaleLang='ru'; // 装箱目前只有中文俄文 模板，英文用俄文的
        }
        //http://bpms.spstoys.com:7291/data/bpms/jreport/conLoadContainer/print?template=jg_load_container_zh&buyerId=&companyId=15&langCode=zh&timestamps=1644977823761&token=CZkfECJG2YO5984&pwd=OySaldPF&lang=zh&containerId=113&%24isGetHttpConfig=true&isCheck=0
        const url =  config.servers[config.environment].exportApi +'/data/bpms/jreport/conLoadContainer/print?template='+'jg_load_container_'+currLocaleLang
            +'&token='+getRandomString(15)+'&pwd='+getRandomString(8)+'&langCode='+currLocaleLang+'&timestamps='+new Date().getTime()+'&lang='+currLocaleLang+'&containerId='+containerId+'&isCheck=0&%24isGetHttpConfig=true';
        window.open(url);*/
        window.location.href=`/shipperManagement/estimatedShippingOrder/bill/${containerId}`
    }
    /**
     * 下载六面图
     * */
    downloadPic(containerId,sType=''){
        this.loading(true);
        const postData = {
            containerId:containerId,
        }
        ShipperManagementAction.downloadPic(postData,sType).then(res=>this.handleDownLoadRes(res.data,containerId,sType)).catch(err=>this.handleDownLoadRes(err));
    }
    // /**
    //  * 下载质检图片
    //  * */
    // downloadQualityPictures(containerId){
    //     this.loading(true);
    //     const postData = {
    //         containerId:containerId,
    //     }
    //     ShipperManagementAction.downloadQualityPic(postData).then(res=>this.handleDownLoadRes(res.data)).catch(err=>this.handleDownLoadRes(err));
    // }
    // handleDownLoadRes(res){
    //     this.loading(false);
    //     // window.open('http://static-foo.essatoy.com/20210063_F2ZVTzeQ_2022-02-15_evdb7KGB.zip');
    //     const {success,valid,model} = res;
    //     if(success&&valid){
    //         if(model&&model.viewName){
    //             window.open(model.viewName);
    //         }else message.warning(Lang({id:'ZanWeiShangChuan',default: '暂未上传'}));
    //     }else if(res.message)message.warning(res.message);
    // }
    /**
     * 下載回調
     * type: 'GoodsPic ：六面圖 ，  'QualityPic'：质检图片，
     * */
    handleDownLoadRes(res={},containerId='',type=''){
        this.loading(false);
        const {success,valid,resultCode, model} = res;
        if(success&&valid){
            if(resultCode=='isEmpty'){ // isEmpty    没有图片  不要打开新tap页下载
                message.warning(Lang({id:'ZanWeiShangChuan',default: '暂未上传'}));
            }else if(model&&model.viewName){
                window.open(model.viewName);
            }else{
                window.open(`/act/shipperManagement/downloading?id=${containerId}&type=${type}`,'_blank')
            }
        }else if(res.message)message.warning(res.message);
    }
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    onSearch(value, event){
        this.onRefAutoFetchListChrld.handleFetch(1,false,{keyword:value})
    }
    /**
     * 下载文件
     * @file 文件地址
     * @flag 是否更新下载标志
     * @iId 集柜单ID
     * */
    clickDownloadFile(file,flag=false,iId){
        if(!isEmpty(file)){
            window.open(file);
            if(flag&&iId){
                const postData = {
                    containerId:iId,
                }
                ShipperManagementAction.uploadTruckingListMark(postData).then(res=>this.handleUpdateDownLoadRes(res.data,iId)).catch(err=>this.handleUpdateDownLoadRes(err,iId));
            }
        }
    }
    handleUpdateDownLoadRes(res,iId){
        const {success,valid,model} = res;
        if(success&&valid){
            this.getDetail(iId);
        }else if(res.message)message.warning(res.message);
    }
    /**
     * 重新上传随车单
     *
     * */
    clickUploadFile(flag=false){
        flag?this.setState({
            showUploadFile:flag,
            title:{
                cnTitle:'重新上传',
                cnTitleId:'ZhongXinShangChuan',
            },
            options:[
            {
                name:'file',
                cnTitle:'文件',
                cnTitleId:'WenJian',
                type:'UploadFile',
                accept:'.xls, .xlsx',
                flagLimitType:true,
                required: true,
                multiple:false,
                maxCount:1,
            }
            ],
        }):this.setState({
            showUploadFile:flag
        })
    }
    /**
     * 重新上传随车单
     *
     * */
    clickConfirmFile(flag=false){
        this.setState({
            showConfirmFile:flag
        })
    }
    handleSaveFile(data,iId){
        if(data&&data.file&&data.file.length>0){
            const file = data.file[0];
            const postData = {
                containerId: iId,
                fileId:file.fileId,
                fileName:file.fileName,
            }
            ShipperManagementAction.uploadTruckingList(postData).then(res=>this.handleSaveFileRes(res.data,iId)).catch(err=>this.handleSaveFileRes(err,iId));

        }
    }
    handleSaveFileRes(res,iId){
        const {success,valid,model} = res;
        if(success&&valid){
            this.clickUploadFile(false);
            this.getDetail(iId);
        }else if(res.message)message.warning(res.message);
    }
    /**
     * 装箱单
     * */
    downloadPackingList(containerId){
        let currLocaleLang = Locale.current();
        if(currLocaleLang=='en'){
            currLocaleLang='ru'; // 装箱目前只有中文俄文 模板，英文用俄文的
        }
        //http://bpms.spstoys.com:7291/data/bpms/jreport/conLoadContainer/print?template=jg_load_container_zh&buyerId=&companyId=15&langCode=zh&timestamps=1644977823761&token=CZkfECJG2YO5984&pwd=OySaldPF&lang=zh&containerId=113&%24isGetHttpConfig=true&isCheck=0
        const url =  config.servers[config.environment].exportApi +'/data/bpms/jreport/conLoadContainer/print?template='+'jg_load_container_'+currLocaleLang
            +'&token='+getRandomString(15)+'&pwd='+getRandomString(8)+'&langCode='+currLocaleLang+'&timestamps='+new Date().getTime()+'&lang='+currLocaleLang+'&containerId='+containerId+'&isCheck=0&%24isGetHttpConfig=true';
        window.open(url);
    }
    componentDidMount() {
        const { search } = this.props.location;
        const sId = this.getCerId(search);
        this.getDetail(sId);
    }
    render(){
        const { loading,model,iId,conTruckingListVO,showConfirmFile,showUploadFile,options,title,statuInfoCount} = this.state;
        const currPageName = Lang({id: "YiChuHuoDingDan",default: "已出货订单"});
        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb list={[{ name:currPageName,link:'/shipperManagement/shippingOrder/list'},{name:Lang({id: "YiChuHuoDingDanXiangQing ",default: "已出货订单详情"})}]}></CommonBreadcrumb>
            <div className="shippedOrderDetailStyle">
                <div className={'topInfo'}>
                    <div className={'title'}>{currPageName}<span>{model.containerCode}</span>
                        <LogisticsInformation
                            poId={model.poId}
                            poCode={model.poCode}
                            leftCode={model.containerCode}
                            rightCode={model.containerNum}
                            logisticsData={model.pubOrderTrackVOS}
                            showPoOutInfo={false} />
                    </div>
                    {/*<p className={'subtitle'}>{Lang({id: "DingDanQingDan",default: "订单清单"})}*/}
                    {/*</p>*/}
                    <div className={'downloadRow'}>
                        <Row>
                            <Col span={18}>
                                <div className={"flex-item"}>
                                    <div className={"info"}>
                                        <span>{model.skuCount||0}</span>
                                        {Lang({id:'Kuan', default:'款'})}，
                                        <span>{model.quantity||0}</span>
                                        {Lang({id:'Xiang',default:'箱'})}
                                    </div>
                                    <div className={"info"}>
                                        {toFixedWithCommas(model.totalVolume,3)||'-'} m³
                                    </div>
                                    <div className={"info"}>
                                        <i className="ri-building-line mr_4"></i>{model.transitCityName}
                                    </div>
                                </div>
                            </Col>
                            <Col span={6}>
                                <Search
                                    placeholder={ Lang({id: "QingShuRuKeHuBianMaHuoShangBinBianMa",default: "请输入客户编码或商品编码",})}
                                    style={{ width: "100%" }}
                                    loading={loading}
                                    onSearch={(value, event)=>this.onSearch(value, event)} />
                            </Col>
                        </Row>
                    </div>
                    <div className={'margin-top-20'}>
                        {/* truckingListStatus 已确认==40 时显示 待确认=40  */}
                        {conTruckingListVO.truckingListStatus==40&&<Alert type="success"
                                                                         message={Lang({id:'YiQueRen',default:'已确认'})}
                                                                         description={<div className={'wrapSuccess'}>
                                                                                 <p>{Lang({id:'YiChuHuoDingDanYiQueRenSuiCheDan',default:'已出货订单已确认随车单'})}</p>
                                                                                 <div className={'downTr'}>
                                                                                    {conTruckingListVO.truckingListCreateBy}
                                                                                    <span>{Lang({id:'GengXinYu',default:'更新于'})}</span>
                                                                                     {conTruckingListVO.truckingListCreateTime?dayjs(conTruckingListVO.truckingListCreateTime).format("YYYY-MM-DD HH:mm"):""}
                                                                                     {conTruckingListVO.truckingListFileUrl&&<span className={'color-blue'}
                                                                                                                                  onClick={()=>this.clickDownloadFile(conTruckingListVO.truckingListFileUrl,false,iId)}>
                                                                                         <span className={'color-blue'}>{Lang({id:'XiaZai',default:'下载'})}</span>
                                                                                     </span>}
                                                                                 </div>
                                                                         </div>}
                                                                         showIcon />}
                        {conTruckingListVO.truckingListStatus==30&&<Alert
                        message={Lang({id:'QingZhuYi',default:'请注意'})}
                        description={<div className={'waringTips'}>
                            <div>
                                <p>{Lang({id:'YiChuHuoDingDanYouDaiQueRenDeSuiCheDan',default:'已出货订单有待确认的随车单，请尽快下载随车单确认'})}</p>
                                <div className={'downTr'}>
                                    {/* 下载文件 */}
                                    {conTruckingListVO&&conTruckingListVO.truckingListFileUrl&&<div className={'color-blue'}
                                                                                                    onClick={()=>this.clickDownloadFile(conTruckingListVO.truckingListFileUrl,true,iId)}>
                                        <VerticalAlignBottomOutlined /> {Lang({id:'XiaZai',default:'下载'})}</div>}
                                    {/* 重新上传 须下载过更新 canUpload为1 后才能重新上传  */}
                                    {conTruckingListVO&&conTruckingListVO.canUpload==1&&<div className={'color-blue'}
                                                                                             onClick={()=>this.clickUploadFile(true)}><ReloadOutlined />{Lang({id:'ZhongXinShangChuan',default:'重新上传'})}</div>}
                                    <span>{conTruckingListVO.truckingListCreateBy}</span>
                                    {Lang({id:'ChuangJianYu',default:'创建于'})}
                                    {conTruckingListVO.truckingListCreateTime?dayjs(conTruckingListVO.truckingListCreateTime).format("YYYY-MM-DD HH:mm"):""}
                                </div>
                            </div>
                                <Button type={'primary'} onClick={()=>this.clickConfirmFile(true)}>{Lang({id: "QueRenSuiCheDan",default: "确认随车单"})}</Button>
                        </div>}
                        type="warning"
                        showIcon
                    />}
                    </div>
                    <div className={'margin-top-15'}>
                        <Space size={'small'}>
                            <Badge count={statuInfoCount}>
                                <Button className={"ant-btn-primary-blue"} onClick={()=>this.showBill(model.containerId)}>{Lang({id: "DanJuGuanLi",default: "单据管理"})}</Button>
                            </Badge>
                            {/* 物流跟进 */}
                            <LogisticsFollowUp containerId={model.containerId} />
                            {/* 清关登记 */}
                            <CustomsClearance containerId={model.containerId}>
                                <Button>{Lang({id: "QingGuanDengJi",default: "清关登记"})}</Button>
                            </CustomsClearance>
                            <FileManagement id={model.containerId}>
                                <Button>{Lang({id: "JiGuiWenJianGuanLi",default: "集柜文件管理"})}</Button>
                            </FileManagement>
                            <Button onClick={()=>this.downloadPackingList(model.containerId)}>{Lang({id: "ZhuangXiangDan",default: "装箱单"})}</Button>
                            <CabinetPicturePreview item={model} loading={flag=>this.loading(flag)} />
                            <Button onClick={()=>this.downloadPic(model.containerId,'GoodsPic')}>{Lang({id: "XiaZaiLiuMianTu",default: "下载六面图"})}</Button>
                            <Button onClick={()=>this.downloadPic(model.containerId,'QualityPic')}>{Lang({id: "XiaZaiZhiJianTuPian",default: "下载质检图片"})}</Button>
                        </Space>
                    </div>
                </div>
                <div className={'itemList'}>
                    {!isEmpty(iId)&&<AutoFetchList onRef={this.onRefAutoFetchList}
                                                   showTotal={false}
                                                   precondition={{containerId:iId}}
                                                   fetchApi={'/service/mg/container/orderDetails'} //http://rap.essa.top:88/workspace/myWorkspace.do?projectId=239#6849
                                                   renderList={(item,inx)=>this.renderList(item,inx,iId)} />}
                </div>
                {showConfirmFile&&<EssaModal title={Lang({id:'QueRenSuiCheDan',default:'确认随车单'})}
                                             open={showConfirmFile}
                                       width={500}
                                       onOk={()=>this.updateData(iId)}
                                       onCancel={()=>this.clickConfirmFile(false)}>
                    <p>{Lang({id: "SuiCheDanQRueRenHouJiangWuFaZaiCiSiuGai",default: "随车单确认后将无法再次修改，将按照确认的随车单进行报关"})}</p>
                </EssaModal>}

                {showUploadFile&&<ModalFormComponent loading={loading}
                                                showModal={showUploadFile}
                                                title={title}
                                                options={options}
                                                saveFormValue={(data)=>this.handleSaveFile(data,iId)}
                                                handleCancel={()=>this.clickUploadFile()} />}
            </div>
        </Spin>)
    }
}
export default EstimatedShippingOrderDetail;
